{
  "Sidebar": {
    "badges": {
      "beta": "बीटा"
    },
    "guest": {
      "title": "अपना कार्य सुरक्षित करें",
      "description": "अपनी परीक्षाओं, चैट और सेटिंग्स को स्थायी रूप से सहेजने के लिए मुफ्त में साइन अप करें।",
      "loginButton": "अभी लॉगिन करें"
    },
    "actions": {
      "newExamTitle": "नई परीक्षा बनाएं",
      "creating": "बनाया जा रहा है...",
      "newExam": "नई परीक्षा"
    },
    "examList": {
      "title": "मेरी परीक्षाएँ",
      "noExams": "कोई परीक्षा नहीं मिली।",
      "unnamed": "बिना नाम का",
      "unnamedExam": "बिना नाम की परीक्षा",
      "loadOlder": "पुरानी परीक्षाएँ लोड करें"
    },
    "examMenu": {
      "edit": "संपादित करें",
      "addToClass": "कक्षा में जोड़ें",
      "delete": "हटाएं"
    },
    "bottomNav": {
      "profile": "प्रोफ़ाइल",
      "settings": "सेटिंग्स",
      "feedback": "फ़ीडबैक दें"
    },
    "dialogs": {
      "renameTitle": "परीक्षा संपादित करें",
      "groupTitle": "परीक्षा को समूहित करें",
      "renameDesc": "परीक्षा की जानकारी संपादित करें।",
      "groupDesc": "इस परीक्षा के लिए एक कक्षा या समूह चुनें।",
      "fields": {
        "name": "नाम",
        "subject": "विषय",
        "topic": "टॉपिक",
        "class": "कक्षा",
        "placeholderSelect": "कृपया चुनें..."
      },
      "save": "सहेजें"
    },
    "alerts": {
      "deleteConfirm": "क्या आप वाकई इस परीक्षा को हटाना चाहते हैं?",
      "saveFailed": "सहेजना विफल रहा"
    }
  },
  "Settings": {
    "title": "सेटिंग्स",
    "soon": "जल्द ही आ रहा है",
    "DisplayAndLanguage": {
      "title": "प्रदर्शन और भाषा",
      "languageLabel": "भाषा",
      "languageDesc": "यूज़र इंटरफ़ेस की भाषा चुनें।",
      "themeLabel": "थीम",
      "themeDesc": "लाइट और डार्क मोड के बीच स्विच करें।"
    },
    "AI": {
      "title": "एआई और ग्रेडिंग",
      "strictnessLabel": "एआई अनिश्चितता",
      "strictnessDesc": "यह निर्धारित करता है कि एआई के किस आत्मविश्वास स्तर पर मैन्युअल समीक्षा अनिवार्य है।",
      "strictnessWarning": "चेतावनी: \"उच्च स्वायत्तता\" के साथ, आप केवल तभी मैन्युअल रूप से हस्तक्षेप करते हैं जब एआई अत्यधिक अनिश्चित हो...",
      "gradingKindnessLabel": "ग्रेडिंग की कठोरता",
      "gradingKindnessDesc": "यह निर्धारित करता है कि एआई ग्रेडिंग योजना को कितनी सख्ती से लागू करता है। उदार (Lenient) सीमांत मामलों में छात्र का पक्ष लेता है; सख्त (Strict) योजना का बिल्कुल पालन करता है।",
      "gradingKindnessOptions": {
        "lenient": "उदार",
        "balanced": "संतुलित",
        "strict": "सख्त"
      }
    },
    "Notifications": {
      "title": "सूचनाएं",
      "soon": "जल्द ही आ रहा है",
      "emailLabel": "ईमेल सूचनाएं",
      "emailDesc": "महत्वपूर्ण घटनाओं के बारे में ईमेल सूचनाएं प्राप्त करें",
      "browserLabel": "ब्राउज़र सूचनाएं",
      "browserDesc": "सीधे अपने ब्राउज़र में पुश सूचनाएं प्राप्त करें"
    },
    "About": {
      "title": "Gradias के बारे में",
      "landingPage": "gradias.ai पर जाएं",
      "support": "सहायता और सपोर्ट",
      "imprint": "कानूनी नोटिस",
      "privacy": "गोपनीयता नीति"
    },
    "Account": {
      "title": "डेटा और खाता",
      "exportLabel": "मेरा डेटा निर्यात करें",
      "exportDesc": "सभी अपलोड की गई परीक्षाओं और परिणामों को ज़िप (ZIP) के रूप में डाउनलोड करें",
      "deleteLabel": "मेरा खाता हटाएं",
      "deleteDesc": "अपना डेटा और सभी संबंधित डेटा स्थायी रूप से हटा दें"
    }
  },
  "Profile": {
    "title": "प्रोफ़ाइल",
    "actions": {
      "cancel": "रद्द करें",
      "save": "सहेजें",
      "edit": "संपादित करें"
    },
    "alerts": {
      "saveError": "प्रोफ़ाइल सहेजी नहीं जा सकी।",
      "generalError": "एक त्रुटi हुई है।"
    },
    "personal": {
      "firstName": "पहला नाम",
      "lastName": "अंतिम नाम",
      "name": "नाम",
      "school": "स्कूल",
      "noSchool": "कोई स्कूल निर्दिष्ट नहीं है",
      "email": "ईमेल",
      "emailHint": "ईमेल को यहाँ बदला नहीं जा सकता।",
      "defaultUser": "उपयोगकर्ता",
      "role": {
        "teacher": "शिक्षक",
        "student": "छात्र"
      }
    },
    "teaching": {
      "subjects": "मेरे विषय"
    },
    "rules": {
      "title": "नियम और प्राथमिकताएं",
      "description": "सहेजी गई प्राथमिकताएं जिनका सहायक पालन करता है - चैटिंग, मूल्यांकन और मॉडल समाधान और मूल्यांकन योजनाएं बनाते समय। आप उन्हें यहाँ स्वयं संपादित कर सकते हैं, लेकिन अनुरोध किए जाने पर सहायक उन्हें सीधे चैट में भी आपके लिए समायोजित कर सकता है।",
      "general": "सामान्य",
      "empty": "अभी तक कोई नियम सहेजा नहीं गया है।",
      "addRule": "नियम जोड़ें",
      "removeRule": "नियम हटाएं",
      "limitReached": "अधिकतम सीमा समाप्त",
      "limitHint": "प्रति श्रेणी अधिकतम {{max}} नियम",
      "placeholder": "नियम का वर्णन करें...",
      "categories": {
        "chat_and_workflow": "चैट और कार्यप्रवाह",
        "grading_and_feedback": "मूल्यांकन और फीडबैक",
        "master_solution_design": "मॉडल समाधान",
        "grading_scheme_creation": "मूल्यांकन योजनाएं"
      },
      "categoryDescs": {
        "chat_and_workflow": "सहायक चैट में कैसे उत्तर देता है और कार्यप्रवाह को कैसे नियंत्रित करता है",
        "grading_and_feedback": "उत्तरों का मूल्यांकन कैसे किया जाता है और फीडबैक कैसे तैयार किया जाता है",
        "master_solution_design": "मॉडल समाधान कैसे बनाए जाते हैं",
        "grading_scheme_creation": "मूल्यांकन योजनाएं कैसे संरचित की जाती हैं"
      },
      "grammar": {
        "alwaysUseFi": "हमेशा त्रुटि सूचकांक (FI) का उपयोग करें",
        "alwaysUseFiDesc": "डिफ़ॉल्ट रूप से, अपलोड किए गए मूल्यांकन स्कीम से पहचाने गए किसी भी व्याकरण नियम के बजाय त्रुटि सूचकांक का उपयोग करता है। इसे प्रत्येक परीक्षा के लिए ओवरराइड किया जा सकता है।",
        "languageUseRegradeWordCutoff": "इतने शब्दों के बाद भाषा और अभिव्यक्ति का स्वतः पुनर्मूल्यांकन करें",
        "languageUseRegradeWordCutoffDesc": "जब किसी छात्र के उत्तर को संपादित किया जाता है, तो संबंधित समूह की भाषा और अभिव्यक्ति का स्वतः पुनर्मूल्यांकन तभी होता है जब कम से कम इतने शब्द बदले गए हों (कई छोटे संपादन जुड़ते हैं)।",
        "contentRegradeWordCutoff": "इतने शब्दों के बाद सामग्री का स्वतः पुनर्मूल्यांकन करें",
        "contentRegradeWordCutoffDesc": "0 = हमेशा (डिफ़ॉल्ट) — किसी भी टेक्स्ट परिवर्तन पर सामग्री का तुरंत पुनर्मूल्यांकन होता है। अधिक मान बहुत छोटे संपादनों के लिए स्वतः पुनर्मूल्यांकन को छोड़ देता है।"
      }
    },
    "security": {
      "title": "खाता और सुरक्षा",
      "changePassword": "पासवर्ड बदलें",
      "changePasswordDesc": "अपने खाते की सुरक्षा प्रबंधित करें",
      "logout": "लॉग आउट करें",
      "logoutDesc": "इस डिवाइस से सुरक्षित रूप से लॉग आउट करें"
    },
    "badges": {
      "soon": "जल्द ही आ रहा है"
    }
  },
  "ClassInsights": {
    "overview": "अवलोकन",
    "examCount": "परीक्षाएं",
    "subjectCount": "विषय",
    "gradedCount": "मूल्यांकित",
    "examListTitle": "इस कक्षा की परीक्षाएं",
    "noExams": "इस कक्षा में अभी तक कोई परीक्षा नहीं है।",
    "loading": "जानकारी लोड हो रही है …",
    "statusGraded": "मूल्यांकित",
    "statusInProgress": "प्रगति पर",
    "unnamedExam": "अनाम परीक्षा",
    "unknownSubject": "अज्ञात विषय"
  },
  "Dashboard": {
    "guestMessage": "मैं gradi हूँ, आपका एआई परीक्षा सुधार सहायक।",
    "greetings": {
      "opt1": "आज हम कौन सी परीक्षाएँ सही करने जा रहे हैं?",
      "opt2": "आइए आपकी परीक्षाओं के इस ढेर को निपटाएं।",
      "opt3": "आज का क्या कार्यक्रम है?",
      "opt4": "आज मैं आपकी क्या मदद कर सकता हूँ?",
      "opt5": "अच्छा लगा कि आप यहाँ हैं। हम कहाँ से शुरू करें?",
      "opt6": "आइए सुधार करना शुरू करें!"
    },
    "fallbackGreeting": "आज का क्या कार्यक्रम है?",
    "greetingPrefix": "हाय",
    "inputPlaceholder": "एक प्रश्न पूछें...",
    "dropzoneText": "फ़ाइलें यहाँ छोड़ें",
    "actions": {
      "startGrading": {
        "label": "परीक्षा सुधार शुरू करें",
        "prompt": "मैं एक नया परीक्षा सुधार शुरू करना चाहता हूँ। कृपया अपलोड से लेकर मूल्यांकन योजना तक की प्रक्रिया में कदम-दर-कदम मेरा मार्गदर्शन करें।"
      },
      "howItWorks": {
        "label": "gradias कैसे काम करता है?",
        "prompt": "कृपया मुझे संक्षेप में और स्पष्ट रूप से समझाएं कि gradias कैसे काम करता है और एक सफल सुधार के लिए मुझे कौन से कदम उठाने होंगे।"
      },
      "sampleData": {
        "label": "नमूना डेटा के साथ परीक्षण करें",
        "prompt": "मैं सिस्टम का परीक्षण करना चाहता हूँ, लेकिन मेरे पास अपनी कोई परीक्षा नहीं है। मैं नमूना परीक्षा के साथ परीक्षण कैसे कर सकता हूँ?"
      },
      "taskTypes": {
        "label": "किस प्रकार के प्रश्न उपलब्ध हैं?",
        "prompt": "आप वर्तमान में किस प्रकार के प्रश्नों (जैसे मुक्त पाठ, बहुविकल्पीय, गणितीय समीकरण) को सही कर सकते हैं?"
      },
      "privacy": {
        "label": "डेटा सुरक्षा और गोपनीयता",
        "prompt": "gradias डेटा सुरक्षा के मुद्दे को कैसे संभालता है? मेरे छात्रों की अपलोड की गई परीक्षाओं का क्या होता है?"
      }
    },
    "alerts": {
      "uploadError": "फ़ाइल अपलोड करते समय त्रुटि",
      "noExamId": "कोई examId मौजूद नहीं है"
    },
    "aria": {
      "uploadFiles": "फ़ाइलें अपलोड करें",
      "submit": "जमा करें",
      "removeFile": "फ़ाइल हटाएं"
    }
  },
  "ChatInput": {
    "statusLabels": {
      "allComplete": "सभी चरण पूरे हो गए",
      "configRunning": "तैयार - आगे बढ़ने के लिए तैयार",
      "readyForConfig": "कॉन्फ़िगरेशन के लिए तैयार",
      "status": "स्थिति",
      "progress": "प्रगति",
      "inProgress": "चल रहा है"
    },
    "steps": {
      "examCreator": {
        "label": "परीक्षा बनाएं",
        "phasePlan": "परीक्षा की योजना बनाई जा रही है",
        "phaseMaterial": "आकृतियाँ बनाई जा रही हैं",
        "phaseSource": "प्रश्न लिखे जा रहे हैं",
        "phaseRepair": "दस्तावेज़ को अंतिम रूप दिया जा रहा है"
      },
      "upload": {
        "label": "फ़ाइल अपलोड"
      },
      "studentAssignment": {
        "label": "छात्र असाइनमेंट",
        "activeWait": "पुष्टि की प्रतीक्षा है",
        "activeAssign": "छात्रों के सबमिशन असाइन करें"
      },
      "structure": {
        "label": "परीक्षा संरचना",
        "active": "प्रश्नों की पहचान की जा रही है"
      },
      "answers": {
        "label": "छात्रों के उत्तर",
        "active": "उत्तरों को प्रोसेस किया जा रहा है"
      },
      "masterSolution": {
        "label": "मॉडल समाधान",
        "activeDetect": "मॉडल समाधान की पहचान की जा रही है",
        "activeCreate": "मॉडल समाधान बनाया जा रहा है",
        "activeComplete": "आदर्श समाधान पूरा किया जा रहा है"
      },
      "gradingScheme": {
        "label": "मूल्यांकन मानदंड",
        "activeDetect": "मूल्यांकन मानदंडों की पहचान की जा रही है",
        "activeCreate": "मूल्यांकन मानदंड बनाए जा रहे हैं",
        "activeComplete": "मूल्यांकन मानदंड पूरे किए जा रहे हैं"
      },
      "grading": {
        "label": "सुधार",
        "active": "सुधार चल रहा है"
      },
      "summary": {
        "label": "परिणाम अवलोकन"
      }
    },
    "badges": {
      "uncertainties": "अनिश्चितताएं",
      "errorRegions": "त्रुटिपूर्ण क्षेत्र",
      "errorSubmissions": "त्रुटिपूर्ण सबमिशन",
      "documentEncrypted": "दस्तावेज़ एन्क्रिप्टेड है"
    },
    "ui": {
      "showProgress": "सुधार की प्रगति दिखाएं",
      "dropFilesHere": "फ़ाइलें यहाँ छोड़ें",
      "uploadFiles": "फ़ाइलें अपलोड करें",
      "waitUpload": "अपलोड होने की प्रतीक्षा करें",
      "sendMessage": "संदेश भेजें",
      "privacyNotice": "100% जीडीपीआर (GDPR) के अनुरूप। आपके डेटा और छात्रों के दस्तावेज़ों का उपयोग एआई प्रशिक्षण के लिए नहीं किया जाता है。",
      "learnMore": "अधिक जानें।"
    },
    "alerts": {
      "uploadError": "Flhler beim Hochladen der Datei",
      "noExamId": "Keine examId vorhanden"
    }
  },
  "TokenInput": {
    "placeholder": "एक प्रश्न पूछें..."
  },
  "Chat": {
    "auth": {
      "login": "लॉग इन करें",
      "register": "रजिस्टर करें"
    },
    "loading": {
      "masterSolutions": "मॉडल समाधान लोड हो रहे हैं...",
      "examData": "परीक्षा डेटा और छवियां लोड हो रही हैं...",
      "extractingTasks": "प्रश्न निकाले जा रहे हैं... {{finished}}/{{total}}",
      "splitThinkingMessage": "मैं छात्रों के सबमिशन व्यवस्थित कर रहा हूँ",
      "structureThinkingMessage": "मैं परीक्षा संरचना की पहचान कर रहा हूँ",
      "examStructure": "परीक्षा संरचना लोड हो रही है...",
      "pages": "पृष्ठ लोड हो रहे हैं...",
      "summary": "सारांश लोड हो रहा है..."
    },
    "alerts": {
      "errorOccurred": "क्षमा करें, एक त्रुटि हुई है। कृपया बाद में पुनः प्रयास करें।",
      "reportsBlocked": "पीडीएफ रिपोर्ट केवल तभी उपलब्ध होंगी जब सभी मुख्य कार्य जारी कर दिए जाएंगे या एआई सुरक्षा {{threshold}}% से अधिक होगी।",
      "noSubmissionsForReports": "रिपोर्ट डेटा के साथ कोई सबमिशन नहीं मिला।",
      "reportsFailed": "पीडीएफ रिपोर्ट नहीं बनाई जा सकीं। कृपया पुनः प्रयास करें।"
    },
    "sampleExamIntro": "मैं निम्नलिखित दस्तावेज़ों के साथ इस परीक्षा को सही करना चाहता हूँ:\n{{lines}}",
    "canvasTitles": {
      "boundingbox": "प्रश्न क्षेत्रों को समायोजित करें",
      "msedit": "मॉडल समाधान / मूल्यांकन योजना संपादित करें",
      "correction": "सुधार",
      "summary": "सुधार सारांश",
      "structureeditor": "परीक्षा संरचना संपादित करें",
      "submissioncheck": "पृष्ठ असाइनमेंट सत्यापित करें",
      "demoselector": "डेमो चुनें",
      "examcreator": "परीक्षा बनाएं",
      "default": "विस्तृत दृश्य"
    }
  },
  "Canvas": {
    "common": {
      "resize": "आकार समायोजित करें",
      "toSummaryTitle": "अवलोकन पर जाएं",
      "backToSummary1": "वापस",
      "backToSummary2": "अवलोकन",
      "restore": "पुनर्स्थापित करें",
      "fullscreen": "पूर्ण स्क्रीन",
      "close": "बंद करें"
    },
    "grading": {
      "prevTask": "पिछला प्रश्न",
      "nextTask": "अगला प्रश्न",
      "taskXofY": "प्रश्न {{current}} में से {{total}}",
      "taskName": "प्रश्न {{number}}",
      "nextUncertainty": "अगली अनिश्चितता ({{count}})",
      "uncertaintiesLeft": "{{count}} अनिश्चितताएं शेष हैं",
      "backToSummary1": "वापस",
      "backToSummary2": "अवलोकन",
      "submissionX": "सबमिशन {{id}}",
      "pages": "पृष्ठ:",
      "pageX": "पृष्ठ {{page}}",
      "addBoundingBox": "नया बाउंडिंग बॉक्स जोड़ें",
      "extractedText": "निकाला गया पाठ",
      "verified": "सत्यापित",
      "consistencyAdjusted": "अन्य सबमिशन के साथ संगति के लिए स्वचालित रूप से समायोजित",
      "bboxConfidence": "बाउंडिंग बॉक्स विश्वसनीयता: {{conf}}%",
      "review": "समीक्षा करें",
      "noTextExtracted": "कोई पाठ नहीं निकाला गया।",
      "imageContent": "छवि (कोई पाठ पहचान नहीं) - पहचानी गई छवि क्लिप का उपयोग सीधे आगे की प्रोसेसिंग के लिए किया जाएगा",
      "aiGrading": "एआई मूल्यांकन",
      "pts": "अंक",
      "points": "अंक:",
      "noGradingYet": "अभी तक कोई मूल्यांकन उपलब्ध नहीं है।",
      "gradingScheme": "मूल्यांकन योजना",
      "expand": "विस्तार करें",
      "collapse": "समेटें",
      "maxPoints": "अधिकतम अंक: {{points}}",
      "noGradingSchemeYet": "अभी तक कोई मूल्यांकन योजना उपलब्ध नहीं है।",
      "boxModeContent": "सामग्री",
      "boxModeLanguageUse": "भाषा और अभिव्यक्ति",
      "groupLanguageUseRule": "समूह: कार्य {{tasks}}",
      "groupLanguageUseRuleNumbered": "समूह {{number}}: कार्य {{tasks}}",
      "editLanguageUseGroupTasks": "इस समूह के कार्य संपादित करें",
      "deleteLanguageUseGroup": "इस भाषा और अभिव्यक्ति नियम को हटाएं",
      "deleteLanguageUseGroupConfirm": "क्या आप वाकई इस भाषा और अभिव्यक्ति नियम को हटाना चाहते हैं? इसे पूर्ववत नहीं किया जा सकता।",
      "deleteLanguageUseGroupBlocked": "मूल्यांकन जारी रहने के दौरान हटाना संभव नहीं है।",
      "languageUseGroupPickerInfo": "किसी कार्य को इस समूह में जोड़ने के लिए उसे चुनें। हटाने के लिए अनचेक करें — यदि उसे अभी भी अपने भाषा और अभिव्यक्ति नियम की आवश्यकता है, तो उसे इस समूह के पाठ और 0 अंकों के साथ पहले से भर दिया जाता है ताकि आप उसे फिर से ढूंढ सकें।",
      "languageUseGroupPickerSaveFailed": "सहेजने में विफल। कृपया पुनः प्रयास करें।",
      "languageUseGroupPickerEmptyDraft": "एक नियम के लिए कम से कम एक कार्य आवश्यक है।",
      "deleteBox": "बाउंडिंग बॉक्स हटाएं",
      "retryOcr": "टेक्स्ट पहचान पुनः प्रयास करें",
      "unlockBox": "बाउंडिंग बॉक्स अनलॉक करें",
      "lockBox": "बाउंडिंग बॉक्स लॉक करें",
      "noSubmissionsFound": "कोई सबमिशन नहीं मिला।",
      "examPageX": "परीक्षा पृष्ठ {{page}}",
      "rerunningOcr": "पाठ पहचान फिर से चल रही है...",
      "regrading": "पुनः मूल्यांकन हो रहा है...",
      "regradingQueued": "कतार में..."
    },
    "msgs": {
      "noTasksFound": "कोई प्रश्न नहीं मिला।",
      "prevTask": "पिछला प्रश्न",
      "nextTask": "अगला प्रश्न",
      "task": "प्रश्न",
      "taskMain": "प्रश्न {{main}}",
      "taskSub": "प्रश्न {{main}}.{{sub}}",
      "uncertaintiesLeft": "{{count}} अनिश्चितताएं शेष हैं",
      "nextUncertainty": "अगली अनिश्चितता ({{count}})",
      "taskExcerpt": "प्रश्न का अंश",
      "noImageAvailable": "कोई छवि उपलब्ध नहीं है...",
      "masterSolution": "मॉडल समाधान",
      "aiGeneratedProposalTooltip": "एआई द्वारा जनरेट किया गया सुझाव",
      "aiGeneratedProposal": "एआई-जनरेटेड सुझाव",
      "review": "समीक्षा करें",
      "approvalRequiresPoints": "जब तक अंक 0 से अधिक न हों, तब तक अनुमोदन संभव नहीं है।",
      "saveRequiresPoints": "जब तक अंक 0 से अधिक न हों, तब तक सहेजना संभव नहीं है।",
      "enterMasterSolution": "मॉडल समाधान यहाँ दर्ज करें...",
      "noMasterSolutionYet": "अभी तक कोई मॉडल समाधान उपलब्ध नहीं है...",
      "gradingScheme": "मूल्यांकन योजना",
      "maxPoints": "अधिकतम अंक",
      "maxPointsValue": "अधिकतम अंक: {{points}}",
      "enterGradingScheme": "मूल्यांकन योजना यहाँ दर्ज करें...",
      "noGradingSchemeYet": "अभी तक कोई मूल्यांकन योजना उपलब्ध नहीं है...",
      "gradingSchemeRefining": "मूल्यांकन मानदंड अपडेट हो रहे हैं...",
      "masterSolutionRefining": "मॉडल समाधान अपडेट हो रहा है..."
    },
    "submissionCheck": {
      "pageShort": "पृ. {{page}}",
      "zoomPage": "पृष्ठ {{page}} बड़ा करें",
      "pageAlt": "पृष्ठ",
      "loading": "लोड हो रहा है...",
      "newStudent": "नया छात्र",
      "readOnly": "केवल पढ़ने के लिए",
      "saveAssignment": "असाइनमेंट सहेजें",
      "unassignedPagesTitle": "स्पष्टीकरण की आवश्यकता: गैर-असाइन किए गए पृष्ठ ({{count}})",
      "unassignedPagesHint": "कृपया इन पृष्ठों को छात्रों के फ़ोल्डरों में खींचें।",
      "newStudentIndexed": "नया छात्र {{index}}",
      "studentIndexed": "छात्र {{index}}",
      "enterName": "नाम दर्ज करें...",
      "pageX_one": "{{count}} पृष्ठ",
      "pageX_other": "{{count}} पृष्ठ",
      "splitConfidenceHover": "विभाजन विश्वसनीयता: {{percent}}%",
      "splitPercent": "विभाजन {{percent}}%",
      "deleteStudent": "छात्र को हटाएं",
      "dragHint": "दस्तावेज़ों को {{name}} को असाइन करने के लिए यहाँ खींचें",
      "assignmentNotes": "असाइनमेंट नोट",
      "previewPageAlt": "पृष्ठ {{page}} का पूर्वावलोकन",
      "pageCurrentOfTotal": "पृष्ठ {{current}} में से {{total}}",
      "locked": "पुष्टि की गई",
      "lockedHint": "पहले से ही पुष्टि की गई है - अब संपादित नहीं किया जा सकता है।"
    },
    "summary": {
      "studentsOverview": "प्रति छात्र सारांश",
      "studentsOverviewDesc": "प्रति प्रश्न विस्तृत अंक और एआई मूल्यांकन",
      "searchStudent": "छात्र का नाम खोजें...",
      "student": "छात्र",
      "pointsAbbr": "अं.",
      "total": "कुल",
      "percentage": "प्रतिशत",
      "grade": "ग्रेड/अंक",
      "noHits": "कोई परिणाम नहीं।",
      "aiConfidenceHover": "एआई विश्वसनीयता: {{percent}}% - कृपया मैन्युअल रूप से जांचें",
      "aiUncertainties": "एआई अनिश्चितताएं",
      "aiUncertaintiesDesc": "निष्पक्ष मूल्यांकन सुनिश्चित करने के लिए उन मामलों की समीक्षा करें जहाँ एआई अनिश्चित है।",
      "openDecisions": "{{count}} लंबित निर्णय",
      "sortBy": "इसके अनुसार क्रमबद्ध करें",
      "task": "प्रश्न",
      "aiUncertainty": "एआई अनिश्चितता",
      "confidence": "एआई विश्वसनीयता:",
      "points": "अंक:",
      "toGrading": "ग्रेडिंग पर जाएं",
      "confirmed": "पुष्टि की गई",
      "confirm": "पुष्टि करें",
      "noClarificationNeeded": "किसी स्पष्टीकरण की आवश्यकता नहीं है।",
      "worstAvg": "सबसे खराब औसत",
      "noDataYet": "अभी तक कोई डेटा नहीं",
      "avgSuffix": "औसत",
      "frequentErrors": "सबसे आम त्रुटि स्रोत",
      "metricsPerTask": "प्रति प्रश्न मेट्रिक्स",
      "gradeDistribution": "ग्रेड वितरण",
      "count": "गिनती",
      "pdfReports": "पीडीएफ रिपोर्ट",
      "downloadingPdf": "पीडीएफ रिपोर्ट बनाई जा रही हैं...",
      "downloadPdf": "पीडीएफ रिपोर्ट डाउनलोड करें",
      "csvExport": "सीएसवी ग्रेड निर्यात",
      "notConnected": "अभी तक कनेक्ट नहीं हुआ",
      "notMet": "पूरा नहीं हुआ",
      "downloadingCsv": "सीएसवी बनाई जा रही है...",
      "downloadCsv": "सीएसवी डाउनलोड करें",
      "gradeScale": "ग्रेडिंग पैमाना",
      "gradeFrom": "ग्रेड {{grade}} से",
      "normalDistribution": "सामान्य वितरण (गॉस वक्र)",
      "activated": "सक्रिय",
      "deactivated": "निष्क्रिय",
      "curveStrength": "कर्विंग ताकत",
      "curvingComingSoon": "कर्विंग सुविधा अभी उपलब्ध नहीं है। यह जल्द ही आएगी।",
      "noSubmissionsFound": "कोई सुधारे गए सबमिशन नहीं मिले।",
      "avgPointsReached": "Ø प्राप्त अंक",
      "pointsReached": "प्राप्त अंक",
      "gradeSystem": "ग्रेडिंग प्रणाली",
      "gradeBorders": "ग्रेड सीमाएं",
      "lowestGradeLabel": "न्यूनतम ग्रेड (0% से)",
      "tabs": {
        "students": "छात्र अवलोकन",
        "clarification": "स्पष्टीकरण की आवश्यकता",
        "insights": "प्रश्न अंतर्दृष्टि",
        "grades": "Grade वितरण",
        "curving": "ग्रेडिंग पैमाना और कर्विंग",
        "export": "निर्यात",
        "languageUse": "भाषा और अभिव्यक्ति & व्याकरण"
      },
      "gradingScales": {
        "german16": "जर्मन (1–6)",
        "drittel": "तिहाई (1.0–5.0)",
        "af": "A–F",
        "gpa4": "4.0 जीपीए (GPA)",
        "notenpunkte": "ग्रेड अंक (0–15)",
        "numeric10": "10-अंक",
        "percentage": "प्रतिशत",
        "custom": "कस्टम"
      },
      "grammar": "व्याकरण",
      "fehlerindex": "त्रुटि सूचकांक (FI)",
      "grammarFiColumnHint": "इसमें केवल वे कार्य शामिल हैं जिन्हें अभी भी त्रुटि सूचकांक के माध्यम से ग्रेड किया जाता है; नियम-आधारित कार्यों के अपने अलग कॉलम होते हैं।",
      "taskLanguageUseColumn": "{{label}} · भाषा और अभिव्यक्ति",
      "grammarTab": {
        "noGrammarTasks": "इस परीक्षा में व्याकरण मूल्यांकन वाले कार्य नहीं हैं।",
        "fiTitle": "त्रुटि सूचकांक कटौती",
        "fiDesc": "त्रुटि सूचकांक = प्रति 100 शब्दों में त्रुटियाँ। सीमाएँ पार करने पर अंतिम ग्रेड ग्रेड-चरणों में घटाया जाता है।",
        "fiUnsupportedScale": "प्रतिशत ग्रेडिंग स्केल के साथ ग्रेड-चरण कटौती संभव नहीं है।",
        "fiAbove": "यदि त्रुटि सूचकांक इससे अधिक है",
        "deductSteps": "कटौती (ग्रेड-चरण)",
        "matrixTitle": "प्रति छात्र और कार्य व्याकरण त्रुटियाँ",
        "matrixDesc": "त्रुटियों की संख्या (कोष्ठक में त्रुटि सूचकांक)। सेल पर क्लिक करने से व्याकरण मोड में सुधार खुलता है।",
        "fiSwitchTitle": "इस परीक्षा के लिए त्रुटि सूचकांक लागू करें",
        "fiSwitchDesc": "डिफ़ॉल्ट रूप से आपकी प्रोफ़ाइल सेटिंग का उपयोग होता है; केवल इस परीक्षा के लिए बदलने हेतु टॉगल करें।",
        "gradeWithFi": "ग्रेड (FI सहित)"
      },
      "languageUseTab": {
        "rulesOverviewTitle": "ग्रेडिंग में उपयोग किए गए भाषा और अभिव्यक्ति नियम",
        "ownRuleEntry": "{{label}}: अपना नियम ({{points}} अंक)",
        "groupRuleEntry": "{{label}} ({{points}} अंक)",
        "teacherRulesActive": "भाषा और अभिव्यक्ति का मूल्यांकन आपके व्यक्तिगत नियमों के अनुसार सीधे ग्रेडिंग में होता है। त्रुटि सूचकांक कटौती निष्क्रिय है।"
      }
    },
    "structureEditor": {
      "pointsInconsistent": "अंक मेल नहीं खा रहे हैं। हर स्तर पर या तो सभी कार्यों को अंक दें (जिनका योग मूल कार्य के कुल के बराबर हो) या सभी को खाली छोड़ दें। हाइलाइट किए गए कार्यों को ठीक करें:",
      "pointsInconsistentTask": "कार्य {{path}} में अंक नहीं हैं",
      "totalPoints": "कुल अंक (उप-कार्यों सहित)",
      "ownPoints": "स्वयं के अंक (इस कार्य का अपना उत्तर)",
      "tasksWithoutRegion": "बिना चिह्नित क्षेत्र वाले कार्य",
      "noPages": "कोई पृष्ठ मौजूद नहीं है।",
      "taskAreasDetected_one": "{{count}} प्रश्न क्षेत्र की पहचान की गई",
      "taskAreasDetected_other": "{{count}} प्रश्न क्षेत्रों की पहचान की गई",
      "addArea": "क्षेत्र जोड़ें",
      "remove": "हटाएं",
      "resetZoom": "ज़ूम रीसेट करें",
      "readOnly": "केवल पढ़ने के लिए",
      "saving": "सहेजा जा रहा है...",
      "saved": "सहेजा गया",
      "blankExamPage": "खाली परीक्षा पृष्ठ {{page}}",
      "deleteBbx": "BBX हटाएं",
      "retryOcr": "टेक्स्ट पहचान पुनः प्रयास करें",
      "noTasksOnPage": "इस पृष्ठ पर कोई प्रश्न नहीं है",
      "task": "प्रश्न",
      "noText": "कोई पाठ नहीं",
      "imageContent": "छवि (कोई पाठ पहचान नहीं) - पहचानी गई छवि क्लिप का उपयोग सीधे आगे की प्रोसेसिंग के लिए किया जाएगा",
      "additionalInfo": "अतिरिक्त जानकारी",
      "noContent": "कोई सामग्री नहीं",
      "linkedTasks": "लिंक्ड प्रश्न",
      "noTasks": "कोई प्रश्न नहीं"
    },
    "demoSelector": {
      "title": "डेमो चुनें",
      "description": "एक नमूना परीक्षा चुनें। gradias अपलोड का अनुकरण करेगा और स्वचालित रूप से निष्कर्षण शुरू कर देगा।",
      "examCount_one": "{{count}} परीक्षा",
      "examCount_other": "{{count}} परीक्षाएँ",
      "studentCount_one": "{{count}} छात्र",
      "studentCount_other": "{{count}} छात्र",
      "examLanguage": "परीक्षा की भाषा",
      "subjects": {
        "math": "गणित",
        "english": "अंग्रेज़ी",
        "technical": "व्यावसायिक स्कूल",
        "biology": "जीव विज्ञान",
        "spanish": "स्पैनिश",
        "french": "फ़्रेंच",
        "physics": "भौतिकी",
        "political_education": "राजनीति शिक्षा",
        "german": "जर्मन"
      },
      "grades": {
        "gesamtschule": "व्यापक स्कूल",
        "highSchool": "हाई स्कूल / जिमनेजियम",
        "elementarySchool": "प्राथमिक विद्यालय",
        "vocationalSchool": "वयस्क शिक्षा",
        "middleSchool": "माध्यमिक विद्यालय",
        "university": "विश्वविद्यालय",
        "primarySchool": "प्राथमिक विद्यालय"
      },
      "exams": {
        "kaarst": {
          "name": "गणित जीके वक्र चर्चा",
          "description": "पूर्ण डेटासेट: छात्र सबमिशन, मॉडल समाधान, मूल्यांकन योजना और खाली परीक्षा"
        },
        "arne": {
          "name": "गणित छठी कक्षा भिन्न",
          "description": "छात्र सबमिशन"
        },
        "lynehamMath": {
          "name": "गणित",
          "description": "छात्र सबमिशन"
        },
        "tuevBauleiter": {
          "name": "निर्माण प्रबंधक",
          "description": "छात्र सबमिशन और मॉडल समाधान"
        },
        "tuvPhotovoltaik": {
          "name": "फोटोवोल्टिक",
          "description": "छात्र सबमिशन और model समाधान"
        },
        "engVocabulary": {
          "name": "शब्दावली परीक्षण (अंग्रेज़ी)",
          "description": "पूर्ण डेटासेट: छात्र सबमिशन, मॉडल समाधान, मूल्यांकन योजना और खाली परीक्षा"
        },
        "bioImageLabeling": {
          "name": "छवि लेबलिंग (जीव विज्ञान)",
          "description": "पूर्ण डेटासेट: छात्र सबमिशन, मॉडल समाधान और खाली परीक्षा"
        },
        "mathProofFr": {
          "name": "गणितीय प्रमाण",
          "description": "पूर्ण डेटासेट: छात्र सबमिशन, मॉडल समाधान और खाली परीक्षा"
        },
        "mathProofEng": {
          "name": "गणितीय प्रमाण",
          "description": "पूर्ण डेटासेट: छात्र सबमिशन, मॉडल समाधान और खाली परीक्षा"
        },
        "plotting": {
          "name": "ग्राफ़ बनाना",
          "description": "पूर्ण डेटासेट: छात्र सबमिशन, मॉडल समाधान और खाली परीक्षा"
        },
        "curveAnalysis": {
          "name": "वक्र चर्चा",
          "description": "पूर्ण डेटासेट: छात्र सबमिशन, मॉडल समाधान और खाली परीक्षा"
        },
        "calculationDe": {
          "name": "भौतिकी",
          "description": "पूर्ण डेटासेट: छात्र सबमिशन, model समाधान, मूल्यांकन योजना और खाली परीक्षा"
        },
        "dictationFr": {
          "name": "श्रुतलेख — फ़्रेंच",
          "description": "पूर्ण डेटासेट: छात्र सबमिशन, मॉडल समाधान, मूल्यांकन योजना और खाली परीक्षा"
        },
        "dictationEs": {
          "name": "श्रुतलेख — स्पैनिश",
          "description": "पूर्ण डेटासेट: छात्र सबमिशन, मॉडल समाधान, मूल्यांकन योजना और खाली परीक्षा"
        },
        "calculationFr": {
          "name": "गणना",
          "description": "पूर्ण डेटासेट: छात्र सबमिशन, मॉडल समाधान, मूल्यांकन योजना और खाली परीक्षा"
        },
        "calculationEs": {
          "name": "गणना",
          "description": "पूर्ण डेटासेट: छात्र सबमिशन, मॉडल समाधान, मूल्यांकन योजना और खाली परीक्षा"
        },
        "calculationEn": {
          "name": "गणना",
          "description": "पूर्ण डेटासेट: छात्र सबमिशन, मॉडल समाधान, मूल्यांकन योजना और खाली परीक्षा"
        },
        "multipleChoiceDe": {
          "name": "बहुविकल्पीय",
          "description": "पूर्ण डेटासेट: छात्र सबमिशन, मॉडल समाधान, मूल्यांकन योजना और खाली परीक्षा"
        },
        "multipleChoiceEn": {
          "name": "बहुविकल्पीय",
          "description": "पूर्ण डेटासेट: छात्र सबमिशन, मॉडल समाधान, मूल्यांकन योजना और खाली परीक्षा"
        },
        "multipleChoiceFr": {
          "name": "बहुविकल्पीय",
          "description": "पूर्ण डेटासेट: छात्र सबमिशन, मॉडल समाधान, मूल्यांकन योजना और खाली परीक्षा"
        },
        "multipleChoiceEs": {
          "name": "बहुविकल्पीय",
          "description": "पूर्ण डेटासेट: छात्र सबमिशन, मॉडल समाधान, मूल्यांकन योजना और खाली परीक्षा"
        },
        "politics12German": {
          "name": "राजनीति शिक्षा — कक्षा 12",
          "description": "पूर्ण डेटासेट: छात्र सबमिशन, मॉडल समाधान, मूल्यांकन योजना और खाली परीक्षा"
        },
        "poetry12German": {
          "name": "कविता विश्लेषण — कक्षा 12",
          "description": "पूर्ण डेटासेट: छात्र सबमिशन, मॉडल समाधान, मूल्यांकन योजना और खाली परीक्षा"
        },
        "poetry12English": {
          "name": "कविता विश्लेषण — कक्षा 12",
          "description": "पूर्ण डेटासेट: छात्र सबमिशन, मॉडल समाधान, मूल्यांकन योजना और खाली परीक्षा"
        },
        "poetry12French": {
          "name": "कविता विश्लेषण — कक्षा 12",
          "description": "पूर्ण डेटासेट: छात्र सबमिशन, मॉडल समाधान, मूल्यांकन योजना और खाली परीक्षा"
        },
        "materialBasedEnglish": {
          "name": "सामग्री-आधारित निबंध",
          "description": "पूर्ण डेटासेट: छात्र सबमिशन, मॉडल समाधान, मूल्यांकन योजना और खाली परीक्षा"
        },
        "materialBasedGerman": {
          "name": "सामग्री-आधारित निबंध",
          "description": "पूर्ण डेटासेट: छात्र सबमिशन, मॉडल समाधान, मूल्यांकन योजना और खाली परीक्षा"
        }
      }
    },
    "examEditor": {
      "savingAndRecompiling": "सहेजा और फिर से संकलित किया जा रहा है…",
      "unsavedChanges": "असहेजे गए परिवर्तन",
      "allChangesSaved": "सभी परिवर्तन सहेजे गए",
      "readOnlyBanner": "यह परीक्षा लॉक है: पहले से ही एक मॉडल समाधान, अंकन योजना या छात्रों के उत्तर मौजूद हैं, इसलिए अब यहाँ कोई बदलाव नहीं किया जा सकता।",
      "generatingExam": "परीक्षा तैयार की जा रही है…",
      "refiningExam": "परीक्षा अपडेट की जा रही है…",
      "downloadPdf": "PDF डाउनलोड करें",
      "preparingPdf": "PDF तैयार किया जा रहा है…",
      "notSaved": "सहेजा नहीं गया: {{message}}",
      "seeProblemsBelow": "नीचे समस्याएं देखें",
      "noExam": "कोई परीक्षा नहीं।",
      "noSourceYet": "इस परीक्षा का अभी तक कोई स्रोत नहीं है।",
      "noPreviewYet": "अभी तक कोई संकलित पूर्वावलोकन नहीं है — संपादित करने और एक बनाने के लिए किसी भी ब्लॉक या डॉट पर क्लिक करें।",
      "tellAiPlaceholder": "AI को बताएं कि क्या बदलना है ...",
      "delete": "हटाएं",
      "applying": "लागू किया जा रहा है …",
      "send": "भेजें",
      "done": "पूर्ण",
      "describeAiPlaceholder": "AI को बताएं कि यहां कौन सा कार्य जोड़ना है ...",
      "add": "जोड़ें",
      "adding": "जोड़ा जा रहा है …",
      "task": "कार्य {{number}}",
      "taskNumber": "कार्य संख्या",
      "type": "प्रकार",
      "points": "अंक",
      "lines": "पंक्तियां",
      "taskText": "कार्य पाठ",
      "material": "सामग्री",
      "title": "शीर्षक",
      "usedByTasks": "किन कार्यों द्वारा उपयोग किया गया (अल्पविराम से अलग की गई संख्याएं)",
      "text": "पाठ",
      "multipleChoice": "बहुविकल्पीय",
      "removeOption": "विकल्प हटाएं",
      "addOption": "+ विकल्प जोड़ें",
      "figureProperties": "आकृति गुण",
      "caption": "कैप्शन",
      "examSetup": "परीक्षा सेटअप",
      "subject": "विषय",
      "class": "कक्षा",
      "duration": "अवधि",
      "totalPoints": "कुल अंक",
      "globalHints": "सामान्य संकेत / निर्देश",
      "studentView": "ऑनलाइन भरें"
    }
  },
  "TaskTypeDescs": {
    "taskFrame": "उप-प्रश्नों को समूहित करता है, इसके लिए किसी अपने उत्तर की आवश्यकता नहीं होती है",
    "default": "सामान्य प्रश्न प्रकार, जब कोई अन्य उपयुक्त न हो",
    "shortText": "संक्षिप्त लिखित उत्तर (कुछ वाक्य)",
    "essay": "लंबा, संरचित पाठ",
    "diagram": "तकनीकी ड्राइंग, जैसे फ़्लोचार्ट या सर्किट आरेख",
    "sketch": "फ्रीहैंड ड्राइंग या स्केच",
    "gapText": "रिक्त स्थान भरें",
    "labelImage": "किसी छवि या आरेख के भागों को लेबल करें",
    "multipleChoice": "दिए गए विकल्पों में से चुनें",
    "imageAnalysis": "छवि का वर्णन या व्याख्या करें",
    "mapping": "मिलान वाली वस्तुओं/विकल्पों को जोड़ें",
    "legalCase": "कानूनी मामला (विशेषज्ञ शैली)",
    "calculation": "गणितीय या भौतिक गणना",
    "mathematicalProof": "औपचारिक गणितीय प्रमाण",
    "curveAnalysis": "वक्र विश्लेषण (शून्य, चरम सीमा, ...)",
    "plotting": "समन्वय प्रणाली में ग्राफ़, फ़ंक्शन या बिंदु प्लॉट करें",
    "geometry": "ज्यामितीय रचनाएँ या गणनाएँ (ड्राइंग)",
    "programming": "सोर्स कोड लिखें या उसका विश्लेषण करें",
    "art": "कलाकृति या कलात्मक डिज़ाइन बनाएं",
    "dictation": "श्रुतलेख (डिक्टेशन) पाठ लिखें",
    "translation": "पाठ या शब्दों का दूसरी भाषा में अनुवाद करें",
    "chemicalFormula": "रासायनिक प्रतिक्रिया समीकरण या सूत्र",
    "music": "संगीत के नोट पढ़ें या लिखें",
    "literaryAnalysisPoetry": "एक कविता का विश्लेषण करें",
    "analysisNonFiction": "एक गैर-काल्पनिक पाठ का विश्लेषण करें",
    "materialBasedEssay": "दी गई सामग्री के आधार पर निबंध लिखें"
  },
  "TaskTypes": {
    "taskFrame": "कार्य ढांचा",
    "default": "मानक",
    "shortText": "लघु पाठ",
    "essay": "निबंध",
    "diagram": "आरेख",
    "sketch": "स्केच",
    "gapText": "रिक्त स्थान भरना",
    "labelImage": "छवि लेबलिंग",
    "multipleChoice": "बहुविकल्पीय",
    "imageAnalysis": "छवि विश्लेषण",
    "mapping": "मिलान करना",
    "legalCase": "कानूनी मामला",
    "calculation": "गणना",
    "mathematicalProof": "गणितीय प्रमाण",
    "curveAnalysis": "वक्र विश्लेषण",
    "plotting": "ग्राफ़ बनाना",
    "geometry": "ज्यामिति",
    "programming": "प्रोग्रामिंग",
    "art": "कला",
    "dictation": "श्रुतलेख",
    "translation": "अनुवाद",
    "chemicalFormula": "रासायनिक सूत्र",
    "music": "संगीत",
    "literaryAnalysisPoetry": "काव्य विश्लेषण",
    "analysisNonFiction": "गैर-काल्पनिक पाठ विश्लेषण",
    "materialBasedEssay": "सामग्री-आधारित निबंध"
  },
  "GapText": {
    "gap": "रिक्त स्थान",
    "correct": "सही",
    "incorrect": "गलत",
    "empty": "खाली",
    "points": "अंक",
    "expectedAnswer": "अपेक्षित उत्तर",
    "studentAnswer": "छात्र का उत्तर",
    "status": "स्थिति"
  },
  "progress": {
    "analyzingSplit": "विभाजन का विश्लेषण किया जा रहा है",
    "extractingAnswers": "छात्रों के उत्तर निकाले जा रहे हैं...",
    "errorExtractingAnswers": "छात्रों के उत्तर निकालने में त्रुटि",
    "answersExtracted": "छात्रों के उत्तर निकाल लिए गए हैं",
    "extractingMasterSolution": "मॉडल समाधान सामग्री निकाली जा रही है",
    "errorStructureMasterSolution": "प्रश्न संरचना (मॉडल समाधान) बनाने में त्रुटि",
    "errorExtractingMasterSolution": "मॉडल समाधान निकालने में त्रुटि",
    "masterSolutionExtracted": "मॉडल समाधान निकाल लिया गया है",
    "extractingGradingScheme": "मूल्यांकन मानदंड निकाले जा रहे हैं",
    "errorStructureGradingScheme": "प्रश्न संरचना (मूल्यांकन मानदंड) बनाने में त्रुटि",
    "errorExtractingGradingScheme": "मूल्यांकन मानदंड निकालने में त्रुटि",
    "gradingSchemeExtracted": "मूल्यांकन मानदंड निकाल लिए गए हैं",
    "noUsableMasterSolution": "कोई उपयोगी मॉडल समाधान सामग्री नहीं मिली। कृपया फ़ाइल की जाँच करें या असाइनमेंट समायोजित करें।",
    "noUsableGradingScheme": "कोई उपयोगी मूल्यांकन मानदंड नहीं मिले। कृपया फ़ाइल की जाँच करें या असाइनमेंट समायोजित करें।",
    "analyzingStructure": "परीक्षा की संरचना का विश्लेषण किया जा रहा है",
    "noSubmissions": "कोई सबमिशन उपलब्ध नहीं है",
    "errorStructureAnalysis": "परीक्षा संरचना विश्लेषण में त्रुटि",
    "noTasksInStructure": "संरचना विश्लेषण में कोई प्रश्न नहीं मिला",
    "extractingTaskDescriptions": "प्रश्न विवरण निकाले जा रहे हैं",
    "errorTaskDescriptions": "प्रश्न विवरण निकालने में त्रुटि",
    "taskDescriptionsExtracted": "प्रश्न विवरण निकाल लिए गए हैं",
    "taskStructureCreated": "प्रश्न संरचना बना दी गई है",
    "waitingForStructureConfirmation": "उपयोगकर्ता द्वारा परीक्षा संरचना की पुष्टि की प्रतीक्षा है",
    "structureConfirmed": "परीक्षा संरचना की पुष्टि हो गई है",
    "structureConfirmationTimeout": "परीक्षा संरचना की पुष्टि का समय समाप्त हो गया है",
    "errorWaitingStructureConfirmation": "परीक्षा संरचना की पुष्टि की प्रतीक्षा करने में त्रुटि",
    "errorProcessingStructureConfirmation": "परीक्षा संरचना की पुष्टि को प्रोसेस करने में त्रुटि",
    "errorCreatingTaskStructure": "प्रश्न संरचना बनाने में त्रुटि",
    "pipelineFailedPrematurely": "पाइपलाइन समय से पहले विफल हो गई",
    "assignmentConfirmed": "असाइनमेंट की पुष्टि हो गई है",
    "gradingRunning": "मूल्यांकन चल रहा है...",
    "gradingTaskX": "प्रश्न {{taskNumber}} का मूल्यांकन किया जा रहा है...",
    "gradingCompleted": "मूल्यांकन पूरा हो गया",
    "gradingTaskXCompleted": "प्रश्न {{taskNumber}} के लिए मूल्यांकन पूरा हो गया"
  },
  "upload": {
    "noExamId": "कोई परीक्षा आईडी नहीं मिली",
    "noFileSelected": "कोई फ़ाइल नहीं चुनी गई",
    "processingFailed": "फ़ाइल को प्रोसेस नहीं किया जा सका",
    "invalidFileType": "अमान्य फ़ाइल प्रकार। कृपया पीएनजी या पीडीएफ फ़ाइल चुनें।",
    "uploadError": "फ़ाइल अपलोड करते समय त्रुटि",
    "studentName": "छात्र {{index}}",
    "noExamIdForReupload": "त्रुटि: पुनः अपलोड करने के लिए कोई परीक्षा आईडी उपलब्ध नहीं है।",
    "reuploadCancelled": "सिस्टम जानकारी: अपलोड रद्द करना प्रोसेस किया गया।",
    "reuploadCancelFailed": "सिस्टम जानकारी: अपलोड रद्द करना पूरी तरह से प्रोसेस नहीं किया जा सका।",
    "filesMissing": "सिस्टम ब्लॉक: अपलोड स्टोरेज में निम्नलिखित फ़ाइलें नहीं मिलीं: {{files}}। कृपया सुनिश्चित करें कि फ़ाइल नाम अपलोड की गई फ़ाइलों से बिल्कुल मेल खाते हैं।",
    "assignmentMismatch": "सिस्टम ब्लॉक: निम्नलिखित फ़ाइल असाइनमेंट अंतिम सुझाव से मेल नहीं खाते हैं। कृपया send_assignment_confirmation_message को कॉल करें और उपयोगकर्ता के साथ नए असाइनमेंट की पुष्टि करें।\n{{lines}}",
    "reuploadStarted": "फ़ाइलों का पुनः अपलोड पृष्ठभूमि में शुरू कर दिया गया है। {{extra}}",
    "splitStarted": "छात्रों के सबमिशन के लिए विभाजन शुरू कर दिया गया है।",
    "assignmentProposalSent": "असाइनमेंट सुझाव के साथ संदेश भेजा गया।",
    "assignmentConfirmationMessage": "मैं अभी फ़ाइल असाइनमेंट के बारे में अनिश्चित हूँ और चाहता हूँ कि आप इसे तुरंत जाँच लें।\n\nकृपया ड्रैग-एंड-ड्रॉप क्षेत्र में पुष्टि करें कि सुझाया गया असाइनमेंट सही है, या इसे वहाँ समायोजित करें। उसके बाद मैं तुरंत आगे बढ़ सकता हूँ।",
    "assignmentProposalFallback": "कृपया मेरे असाइनमेंट सुझाव की जाँच करें और फ़ाइल असाइनमेंट की पुष्टि करें।",
    "categorySubmissions": "छात्रों के सबमिशन",
    "categoryMasterSolution": "मॉडल समाधान",
    "categoryGradingScheme": "मूल्यांकन योजना",
    "categoryBlankExam": "खाली परीक्षा",
    "lowConfidenceListFormat": "'{{file}}' ({{category}} के रूप में योजनाबद्ध)",
    "mismatchFormat": "- {{name}}: हाल ही में \"{{proposed}}\" के रूप में सुझाया गया, अब \"{{supplied}}\" के रूप में प्रदान किया गया"
  },
  "splitIssues": {
    "unknownStudent": "अज्ञात छात्र",
    "studentNumber": "छात्र {{number}}",
    "pageAssignmentError": "प्रत्येक पृष्ठ को ठीक एक बार असाइन नहीं किया गया था",
    "nonConsecutive": "{{names}} के लिए गैर-लगातार पृष्ठ असाइन किए गए (एजेंटों द्वारा पुनर्रचना)",
    "uncertainty": "{{names}} के साथ अनिश्चितता",
    "outlierLongExtremeSingle": "{{names}} का सबमिशन अत्यधिक लंबा है",
    "outlierLongExtremePlural": "{{names}} के सबमिशन अत्यधिक लंबे हैं",
    "outlierShortExtremeSingle": "{{names}} का सबमिशन अत्यधिक छोटा है",
    "outlierShortExtremePlural": "{{names}} के सबमिशन अत्यधिक छोटे हैं",
    "outlierLongSingle": "{{names}} का सबमिशन असामान्य रूप से लंबा है",
    "outlierLongPlural": "{{names}} के सबमिशन असामान्य रूप से लंबे हैं",
    "outlierShortSingle": "{{names}} का सबमिशन असामान्य रूप से छोटा है",
    "outlierShortPlural": "{{names}} के सबमिशन असामान्य रूप से छोटे हैं",
    "missingStudentNameSingle": "{{totalCount}} छात्रों में से {{missingCount}} छात्र के लिए कोई नाम नहीं निकाला जा सका",
    "missingStudentNamePlural": "{{totalCount}} छात्रों में से {{missingCount}} छात्रों के लिए कोई नाम नहीं निकाला जा सका",
    "splitAgentFailure": "स्प्लिट-एजेंट त्रुटि{{suffix}}",
    "errorPrefix": "त्रुटि",
    "warningPrefix": "चेतावनी",
    "parseErrorFallback": "डेटा प्रोसेस नहीं किया जा सका। कृपया कैनवास में असाइनमेंट की जाँच करें।",
    "messageError": "मुझे प्रत्येक {{range}} पृष्ठों वाले {{count}} छात्र मिले हैं, लेकिन पृष्ठों के स्वचालित असाइनमेंट में एक समस्या आई है:\n{{problem}}\n\nकृपया असाइनमेंट कैनवास में असाइनमेंट की जाँच करें और यदि आवश्यक हो तो इसे मैन्युअल रूप से ठीक करें। जैसे ही आप तैयार हों, कृपया चैट में या बटन के माध्यम से पुष्टि करें ताकि हम आगे बढ़ सकें।",
    "messageWarning": "मुझे प्रत्येक {{range}} पृष्ठों वाले {{count}} छात्र मिले हैं, लेकिन निम्नलिखित नोट उपलब्ध हैं:\n{{problem}}\n\nयदि आप चाहें, तो आप असाइनमेंट कैनवास में नोटों की जाँच कर सकते हैं। अन्यथा बस पुष्टि करें ताकि हम आगे बढ़ सकें।",
    "messageSuccess": "मुझे प्रत्येक {{range}} पृष्ठों वाले {{count}} छात्र मिले हैं। असाइनमेंट स्पष्ट था। सभी छात्रों का नाम निकाला जा सका। कृपया पुष्टि करें ताकि हम आगे बढ़ सकें।",
    "confirmationRequested": "विभाजन पुष्टि का अनुरोध किया गया",
    "splitAgentFailed": "छात्रों के सबमिशन का स्वचालित असाइनमेंट विफल रहा। कृपया बाद में फिर से अपलोड करने का प्रयास करें।"
  },
  "structureIssues": {
    "pointsExplanation": "\n\n**अंकों के बारे में:** मैंने कुछ कार्यों के लिए अंक पहचाने हैं। यदि आप अंकों सहित एक मूल्यांकन योजना अपलोड करते हैं (या पहले ही कर चुके हैं), तो अंक वहीं से लिए जाएंगे; तब आप कैनवास के अंकों को अनदेखा कर सकते हैं। वे केवल तभी प्रासंगिक हैं जब आपकी मूल्यांकन योजना में ये अंक न हों या आप एक बनवाना चाहें।\n\nअंक नियम: हर कार्य के लिए या तो सभी प्रत्यक्ष उप-कार्यों को अंक दें जिनका योग मूल कार्य के कुल के बराबर हो, या किसी को नहीं। यदि आप उप-कार्यों को अंक नहीं देते बल्कि केवल कुल देते हैं, तो एआई मूल्यांकन योजना बनाते समय उन्हें स्वतः वितरित कर देगा।",
    "textCutoff": "प्रश्न का पाठ अधूरा है",
    "missingInformation": "लापता जानकारी",
    "imageUnreadable": "छवि अपठनीय है",
    "task": "प्रश्न",
    "mainTasks_one": "मैंने {{mainCount}} मुख्य प्रश्न की पहचान की है।",
    "mainTasks_other": "मैंने {{mainCount}} मुख्य प्रश्नों की पहचान की है।",
    "mainAndSubTasks_one": "मैंने {{mainCount}} मुख्य प्रश्न और {{subCount}} उप-प्रश्न की पहचान की है।",
    "mainAndSubTasks_other": "मैंने {{mainCount}} मुख्य प्रश्न और {{subCount}} उप-प्रश्नों की पहचान की है।",
    "intro": "### मैंने निम्नलिखित प्रश्न संरचना की पहचान की है:\n\n{{countText}}",
    "problemsIntro": "\n\nप्रश्न पहचान के दौरान निम्नलिखित समस्याएं आईं: {{warnings}}। कृपया कैनवास में अनिश्चितताओं को देखें, आवश्यकतानुसार उन्हें संपादित करें और फिर बटन के माध्यम से या चैट में पुष्टि करें।",
    "uncertaintyIntro": "\n\nप्रश्न पहचान में {{labels}} के साथ अनिश्चितताएं हैं। कृपया कैनवास में अनिश्चितताओं को देखें, आवश्यकतानुसार उन्हें संपादित करें और फिर बटन के माध्यम से या चैट में पुष्टि करें。",
    "success": "\n\nप्रश्न पहचान के दौरान कोई समस्या नहीं आई। यदि आप चाहें, तो आप अभी भी कैनवास में उन्हें अधिक विस्तार से देख सकते हैं, अन्यथा कृपया बटन के माध्यम से या चैट में पुष्टि करें।"
  },
  "chatMessages": {
    "emptyState": "नीचे एक संदेश टाइप करके बातचीत शुरू करें",
    "newMessage": "नया संदेश",
    "cancel": "रद्द करें",
    "send": "भेजें",
    "edit": "संपादित करें",
    "editInCanvas": "कैनवास में संपादित करें",
    "confirmed": "पुष्टि की गई",
    "confirm": "पुष्टि करें",
    "confirmAssignment": "असाइनमेंट की पुष्टि करें",
    "giveFeedback": "फ़ीडबैक दें",
    "feedbackTitle": "फ़ीडबैक दें",
    "feedbackDescription": "हमें बताएं कि हम इस उत्तर को कैसे बेहतर बना सकते हैं।",
    "feedbackPlaceholder": "आपका फ़ीडबैक यहाँ...",
    "feedbackSubmit": "फ़ीडबैक भेजें",
    "submitAssignmentConfirmation": "मैं पृष्ठों के विभाजन और छात्रों के असाइनमेंट की पुष्टि करता हूँ। कृपया आगे बढ़ें।",
    "submitStructureConfirmation": "मैं प्रश्न संरचना की पुष्टि करता हूँ",
    "studentSubmissions": "छात्रों के सबमिशन",
    "masterSolution": "मॉडल समाधान",
    "gradingScheme": "मूल्यांकन योजना",
    "blankExam": "खाली परीक्षा",
    "confirmedAssignmentIntro": "पुष्टि की गई फ़ाइल असाइनमेंट:",
    "assignmentIntro": "मैंने फ़ाइलों को निम्नानुसार असाइन किया है। कृपया असाइनमेंट की जाँच करें और इसकी पुष्टि करें:"
  },
  "AuthModal": {
    "loginError": "ईमेल या पासवर्ड गलत है।",
    "signupFailed": "पंजीकरण विफल रहा। कृपया पुनः प्रयास करें।",
    "passwordMismatch": "पासवर्ड मेल नहीं खाते।",
    "forgotPasswordProblem": "एक समस्या थी। कृपया बाद में पुनः प्रयास करें।",
    "waitlistTitle": "आप प्रतीक्षा सूची में हैं!",
    "waitlistDesc": "जैसे ही अगला चरण शुरू होगा, हम आपसे संपर्क करेंगे।",
    "waitlistInactive": "प्रतीक्षा सूची वर्तमान में निष्क्रिय है।",
    "backToLogin": "लॉगिन पर वापस जाएं",
    "linkSentTitle": "लिंक भेज दिया गया है!",
    "linkSentDesc": "समझ गया",
    "forgotPasswordTitle": "पासवर्ड भूल गए?",
    "requestLink": "लिंक का अनुरोध करें",
    "welcomeBack": "आपका स्वागत है",
    "createAccount": "खाता बनाएं",
    "emailLabel": "ईमेल",
    "passwordLabel": "पासवर्ड",
    "forgotPasswordLink": "पासवर्ड भूल गए?",
    "loginButton": "लॉग इन करें",
    "firstNameLabel": "पहला नाम",
    "lastNameLabel": "अंतिम नाम",
    "schoolLabel": "स्कूल",
    "subjectsLabel": "विषय",
    "confirmPasswordLabel": "पुष्टि करें",
    "signupButton": "रजिस्टर करें",
    "registerHere": "यहाँ रजिस्टर करें",
    "loginHere": "यहाँ लॉगिन करें",
    "continueGuest": "बिना लॉगिन के जारी रखें →"
  },
  "FeedbackPage": {
    "alerts": {
      "imageTooLarge": "छवि \"{{name}}\" बहुत बड़ी है (अधिकतम 5MB)।",
      "previewError": "{{name}} के लिए पूर्वावलोकन नहीं बनाया जा सका।",
      "submitError": "कुछ गलत हो गया। कृपया पुनः प्रयास करें।"
    },
    "success": {
      "title": "आपके फ़ीडबैक के लिए बहुत-बहुत धन्यवाद!",
      "description": "हमें आपका संदेश मिल गया है। आपका इनपुट हमें Gradias को हर दिन थोड़ा बेहतर बनाने में बहुत मदद करता है।",
      "backButton": "परीक्षा पर वापस जाएं"
    },
    "header": {
      "title": "फ़ीडबैक दें"
    },
    "content": {
      "description": "क्या आपने कोई त्रुटि देखी है, आपके पास कोई शानदार विचार है या आप हमें कुछ बताना चाहते हैं? हम हर संदेश पढ़ते हैं!"
    },
    "categories": {
      "title": "यह किस बारे में है?",
      "bug": {
        "title": "त्रुटि / बग",
        "desc": "कुछ काम नहीं कर रहा है"
      },
      "feature": {
        "title": "विचार / इच्छा",
        "desc": "एक नई सुविधा"
      },
      "general": {
        "title": "अन्य",
        "desc": "सामान्य फ़ीडबैक"
      }
    },
    "message": {
      "title": "आपका संदेश",
      "placeholder": "अपनी चिंता का यथासंभव विस्तार से वर्णन करें..."
    },
    "upload": {
      "title": "स्क्रीनशॉट संलग्न करें (वैकल्पिक)",
      "clickToSelect": "छवियां चुनने के लिए क्लिक करें",
      "formatConstraint": "प्रति छवि अधिकतम 5MB तक पीएनजी, जेपीजी",
      "attachedImages": "संलग्न छवियां",
      "removeImage": "छवि हटाएं"
    },
    "submit": {
      "sending": "भेजा जा रहा है...",
      "send": "फ़ीडबैक भेजें"
    }
  },
  "ConfirmationReplies": {
    "split": {
      "confirmed": "परीक्षा असाइनमेंट और छात्रों की संख्या सफलतापूर्वक सत्यापित की गई है। प्रश्न संरचना का निष्कर्षण अब शुरू किया जा सकता है। कृपया असाइनमेंट की पुष्टि के लिए उपयोगकर्ता को धन्यवाद दें और चैट में उपयोगकर्ता को सूचित करें कि प्रश्न संरचना का निष्कर्षण अब शुरू होने जा रहा है।",
      "pending": "परीक्षा असाइनमेंट और छात्रों की संख्या की अभी तक पुष्टि नहीं हुई है।"
    },
    "structure": {
      "masterAndGrading": "प्रश्न संरचना सफलतापूर्वक सत्यापित की गई है। निष्कर्षण पृष्ठभूमि में चल रहा है। एक मॉडल समाधान और एक मूल्यांकन कुंजी पहले ही अपलोड की जा चुकी है और पृष्ठभूमि में प्रोसेस की जा रही है। प्रश्न संरचना की पुष्टि के लिए उपयोगकर्ता को संक्षेप में धन्यवाद दें और उपयोगकर्ता को सूचित करें कि निष्कर्षण जारी रहेगा। उन्हें ग्रेडिंग शुरू करने का सुझाव दें।",
      "masterOnly": "प्रश्न संरचना सफलतापूर्वक सत्यापित की गई है। निष्कर्षण पृष्ठभूमि में चल रहा है। एक मॉडल समाधान पहले ही अपलोड किया जा चुका है, लेकिन मूल्यांकन कुंजी अभी भी गायब है। प्रश्न संरचना की पुष्टि के लिए उपयोगकर्ता को संक्षेप में धन्यवाद दें और उपयोगकर्ता को सूचित करें कि निष्कर्षण जारी रहेगा। उन्हें अगले चरण के रूप में एआई-आधारित मूल्यांकन योजना बनाने का सुझाव दें।",
      "gradingOnly": "प्रश्न संरचना सफलतापूर्वक सत्यापित की गई है। निष्कर्षण पृष्ठभूमि में चल रहा है। एक मूल्यांकन कुंजी पहले ही अपलोड की जा चुकी है, लेकिन मॉडल समाधान अभी भी गायब है। प्रश्न संरचना की पुष्टि के लिए उपयोगकर्ता को संक्षेप में धन्यवाद दें और उपयोगकर्ता को सूचित करें कि निष्कर्षण जारी रहेगा। उन्हें एक एआई-आधारित मॉडल समाधान बनाने का सुझाव दें।",
      "none": "प्रश्न संरचना सफलतापूर्वक सत्यापित की गई है। निष्कर्षण पृष्ठभूमि में चल रहा है। मॉडल समाधान अभी भी गायब है। प्रश्न संरचना की पुष्टि के लिए उपयोगकर्ता को संक्षेप में धन्यवाद दें, उपयोगकर्ता को सूचित करें कि निष्कर्षण जारी रहेगा और उपयोगकर्ता से पूछें कि क्या वह अगले चरण में (निष्कर्षण पूरा होने के बाद) एआई-आधारित मॉडल समाधान उत्पन्न करना चाहता है या क्या वह इनपुट फ़ील्ड में पेपरक्लिप के माध्यम से एक मॉडल समाधान अपलोड करना चाहता है। अपने उत्तर में उल्लेख करें कि उपयोगकर्ता मॉडल समाधान कैसे अपलोड कर सकता है, यानी चैट इनपुट फ़ील्ड में पेपरक्लिप के साथ।"
    },
    "errors": {
      "notConfirmed": "Confirmation flag is false; nothing to do.",
      "missingIdentifiers": "Missing required identifiers for confirmation.",
      "missingSplitMessage": "त्रुटि: कोई संबद्ध विभाजन पुष्टि संदेश नहीं मिला।",
      "missingStructureMessage": "त्रुटि: कोई संबद्ध संरचना पुष्टि संदेश नहीं मिला।",
      "structureContentMissing": "त्रुटि: संरचना पुष्टि संदेश लोड नहीं किया जा सका।",
      "splitFailure": "विभाजन की पुष्टि करने में त्रुटि।",
      "structureFailure": "संरचना की पुष्टि करने में त्रुटि।"
    }
  },
  "toolFallbackDesc": {
    "default": "टूल चरण निष्पादित करें",
    "set_metadata": "परीक्षा का मेटाडेटा",
    "create_exam": "परीक्षा अब बनाएँ",
    "generate_master_solution": "अब मॉडल समाधान बनाएं",
    "refine_master_solution": "मॉडल समाधान में विशेष रूप से सुधार करें",
    "generate_grading_scheme": "अब मूल्यांकन योजना बनाएं",
    "refine_grading_scheme": "मूल्यांकन योजना में विशेष रूप से सुधार करें",
    "run_grading_agent": "मूल्यांकन करें",
    "set_task_score": "अंक मैन्युअल रूप से सेट करें",
    "open_canvas": "कैनवास व्यू खोलें",
    "update_open_task_content": "प्रश्न पाठ को सीधे अपडेट करें",
    "send_assignment_confirmation_message": "फ़ाइल असाइनमेंट की पुष्टि करवाएं",
    "process_files": "अपलोड की गई फ़ाइलें प्रोसेस करें",
    "confirm_split_in_chat": "चैट में असाइनमेंट की पुष्टि करें",
    "confirm_structure_in_chat": "चैट में संरचना की पुष्टि करें",
    "query_exams": "परीक्षा डेटा प्राप्त करें",
    "query_submissions": "छात्रों के सबमिशन प्राप्त करें",
    "get_available_options": "उपलब्ध विकल्प प्राप्त करें",
    "get_task_types": "प्रश्न प्रकार प्राप्त करें",
    "download_ms_gs": "मॉडल समाधान/मूल्यांकन योजना डाउनलोड करें",
    "download_summary_reports": "मूल्यांकन रिपोर्ट डाउनलोड करें",
    "save_teacher_memory": "प्राथमिकता याद रखें",
    "get_teacher_memory": "प्राथमिकताएं खोजें",
    "delete_teacher_memory": "प्राथमिकताएं हटाएं",
    "reprocess_errored_submissions": "त्रुटिपूर्ण सबमिशन को फिर से प्रोसेस करें"
  },
  "Subjects": {
    "math": "गणित",
    "physics": "भौतिकी",
    "chemistry": "रसायन विज्ञान",
    "biology": "जीव विज्ञान",
    "history": "इतिहास",
    "geography": "भूगोल",
    "english": "अंग्रेज़ी",
    "german": "जर्मन",
    "french": "फ़्रेंच",
    "spanish": "स्पैनिश",
    "computer_science": "कंप्यूटर विज्ञान",
    "social_studies": "सामाजिक अध्ययन",
    "other": "अन्य"
  },
  "ExamNotifications": {
    "newMessage": "नया संदेश"
  },
  "LanguageUseTemplates": {
    "essay": "स्तर · प्रस्तुति क्षमता\n\n* उत्कृष्ट:\n  - पाठ स्पष्ट और तार्किक रूप से संरचित है, जिसमें अनुभागों के बीच प्रभावी संबंध हैं।\n  - विषय-विशिष्ट भाषा का उपयोग आत्मविश्वास और सटीकता से किया गया है।\n  - उद्धरण सही ढंग से एकीकृत और प्रासंगिक रूप से प्रस्तुत किए गए हैं; प्रमाणों में पंक्ति-संदर्भ शामिल हैं।\n  - वाक्य-रचना विविधतापूर्ण, शैलीगत रूप से आत्मविश्वासपूर्ण और साहित्यिक विषय के अनुकूल है।\n  - व्याकरण, स्पेलिंग और विरामचिह्न लगभग त्रुटिरहित हैं।\n* अच्छा:\n  - पाठ सुसंगत रूप से संरचित है।\n  - विषय-विशिष्ट भाषा का उपयोग अधिकतर आत्मविश्वास से किया गया है।\n  - उद्धरणों का उचित उपयोग किया गया है और सही ढंग से संदर्भित किया गया है।\n  - वाक्य-रचना सही और विविधतापूर्ण है।\n  - व्याकरण, स्पेलिंग और विरामचिह्न में कुछ ही त्रुटियाँ हैं।\n* संतोषजनक:\n  - संरचना पहचानी जा सकती है, लेकिन पूरी तरह सुसंगत नहीं है।\n  - विषय-विशिष्ट भाषा का उपयोग कार्यात्मक है, परंतु हमेशा सटीक नहीं।\n  - उद्धरणों का उपयोग किया गया है, संदर्भ अधिकतर सही हैं।\n  - वाक्य-रचना अधिकतर सही है, कहीं-कहीं नीरस।\n  - व्याकरण, स्पेलिंग और विरामचिह्न की त्रुटियाँ समझ में बाधा नहीं डालतीं।\n* पर्याप्त:\n  - संरचना केवल आधारभूत रूप से पहचानी जा सकती है।\n  - विषय-विशिष्ट भाषा का उपयोग केवल आंशिक या अस्पष्ट रूप से किया गया है।\n  - उद्धरण असंगत हैं या अपूर्ण रूप से संदर्भित हैं।\n  - वाक्य-रचना एकरूप है, जिसमें बार-बार अनिश्चितता है।\n  - भाषा की शुद्धता सीमित है; समझ कभी-कभी बाधित होती है।\n* कमजोर:\n  - प्रस्तुति काफी हद तक असंरचित है।\n  - विषय-विशिष्ट भाषा काफी हद तक अनुपस्थित है या गलत ढंग से प्रयुक्त है।\n  - उद्धरण अनुपस्थित हैं या गलत हैं।\n  - भाषाई कमियाँ समझ को काफी हद तक बाधित करती हैं।\n* अत्यंत कमजोर:\n  - प्रस्तुति इतनी कमजोर है कि कार्य लगभग समझ से परे है।\n  - एक लिखित साहित्यिक व्याख्या निबंध की बुनियादी आवश्यकताएँ स्पष्ट नहीं हैं।",
    "analysisNonFiction": "स्तर · प्रस्तुति क्षमता\n\n* उत्कृष्ट:\n  - पाठ स्पष्ट और तार्किक रूप से संरचित है, जिसमें अनुभागों के बीच प्रभावी संबंध हैं।\n  - विषय-विशिष्ट भाषा का उपयोग आत्मविश्वास और सटीकता से किया गया है।\n  - उद्धरण सही ढंग से एकीकृत और प्रासंगिक रूप से प्रस्तुत किए गए हैं; प्रमाणों में पंक्ति-संदर्भ शामिल हैं।\n  - वाक्य-रचना विविधतापूर्ण, शैलीगत रूप से आत्मविश्वासपूर्ण और साहित्यिक विषय के अनुकूल है।\n  - व्याकरण, स्पेलिंग और विरामचिह्न लगभग त्रुटिरहित हैं।\n* अच्छा:\n  - पाठ सुसंगत रूप से संरचित है।\n  - विषय-विशिष्ट भाषा का उपयोग अधिकतर आत्मविश्वास से किया गया है।\n  - उद्धरणों का उचित उपयोग किया गया है और सही ढंग से संदर्भित किया गया है।\n  - वाक्य-रचना सही और विविधतापूर्ण है।\n  - व्याकरण, स्पेलिंग और विरामचिह्न में कुछ ही त्रुटियाँ हैं।\n* संतोषजनक:\n  - संरचना पहचानी जा सकती है, लेकिन पूरी तरह सुसंगत नहीं है।\n  - विषय-विशिष्ट भाषा का उपयोग कार्यात्मक है, परंतु हमेशा सटीक नहीं।\n  - उद्धरणों का उपयोग किया गया है, संदर्भ अधिकतर सही हैं।\n  - वाक्य-रचना अधिकतर सही है, कहीं-कहीं नीरस।\n  - व्याकरण, स्पेलिंग और विरामचिह्न की त्रुटियाँ समझ में बाधा नहीं डालतीं।\n* पर्याप्त:\n  - संरचना केवल आधारभूत रूप से पहचानी जा सकती है।\n  - विषय-विशिष्ट भाषा का उपयोग केवल आंशिक या अस्पष्ट रूप से किया गया है।\n  - उद्धरण असंगत हैं या अपूर्ण रूप से संदर्भित हैं।\n  - वाक्य-रचना एकरूप है, जिसमें बार-बार अनिश्चितता है।\n  - भाषा की शुद्धता सीमित है; समझ कभी-कभी बाधित होती है।\n* कमजोर:\n  - प्रस्तुति काफी हद तक असंरचित है।\n  - विषय-विशिष्ट भाषा काफी हद तक अनुपस्थित है या गलत ढंग से प्रयुक्त है।\n  - उद्धरण अनुपस्थित हैं या गलत हैं।\n  - भाषाई कमियाँ समझ को काफी हद तक बाधित करती हैं।\n* अत्यंत कमजोर:\n  - प्रस्तुति इतनी कमजोर है कि कार्य लगभग समझ से परे है।\n  - एक लिखित साहित्यिक व्याख्या निबंध की बुनियादी आवश्यकताएँ स्पष्ट नहीं हैं।",
    "genericGroup": "स्तर · प्रस्तुति क्षमता\n\n* उत्कृष्ट:\n  - पाठ स्पष्ट और तार्किक रूप से संरचित है, जिसमें अनुभागों के बीच प्रभावी संबंध हैं।\n  - विषय-विशिष्ट भाषा का उपयोग आत्मविश्वास और सटीकता से किया गया है।\n  - उद्धरण सही ढंग से एकीकृत और प्रासंगिक रूप से प्रस्तुत किए गए हैं; प्रमाणों में पंक्ति-संदर्भ शामिल हैं।\n  - वाक्य-रचना विविधतापूर्ण, शैलीगत रूप से आत्मविश्वासपूर्ण और साहित्यिक विषय के अनुकूल है।\n  - व्याकरण, स्पेलिंग और विरामचिह्न लगभग त्रुटिरहित हैं।\n* अच्छा:\n  - पाठ सुसंगत रूप से संरचित है।\n  - विषय-विशिष्ट भाषा का उपयोग अधिकतर आत्मविश्वास से किया गया है।\n  - उद्धरणों का उचित उपयोग किया गया है और सही ढंग से संदर्भित किया गया है।\n  - वाक्य-रचना सही और विविधतापूर्ण है।\n  - व्याकरण, स्पेलिंग और विरामचिह्न में कुछ ही त्रुटियाँ हैं।\n* संतोषजनक:\n  - संरचना पहचानी जा सकती है, लेकिन पूरी तरह सुसंगत नहीं है।\n  - विषय-विशिष्ट भाषा का उपयोग कार्यात्मक है, परंतु हमेशा सटीक नहीं।\n  - उद्धरणों का उपयोग किया गया है, संदर्भ अधिकतर सही हैं।\n  - वाक्य-रचना अधिकतर सही है, कहीं-कहीं नीरस।\n  - व्याकरण, स्पेलिंग और विरामचिह्न की त्रुटियाँ समझ में बाधा नहीं डालतीं।\n* पर्याप्त:\n  - संरचना केवल आधारभूत रूप से पहचानी जा सकती है।\n  - विषय-विशिष्ट भाषा का उपयोग केवल आंशिक या अस्पष्ट रूप से किया गया है।\n  - उद्धरण असंगत हैं या अपूर्ण रूप से संदर्भित हैं।\n  - वाक्य-रचना एकरूप है, जिसमें बार-बार अनिश्चितता है।\n  - भाषा की शुद्धता सीमित है; समझ कभी-कभी बाधित होती है।\n* कमजोर:\n  - प्रस्तुति काफी हद तक असंरचित है।\n  - विषय-विशिष्ट भाषा काफी हद तक अनुपस्थित है या गलत ढंग से प्रयुक्त है।\n  - उद्धरण अनुपस्थित हैं या गलत हैं।\n  - भाषाई कमियाँ समझ को काफी हद तक बाधित करती हैं।\n* अत्यंत कमजोर:\n  - प्रस्तुति इतनी कमजोर है कि कार्य लगभग समझ से परे है।\n  - एक लिखित साहित्यिक व्याख्या निबंध की बुनियादी आवश्यकताएँ स्पष्ट नहीं हैं।",
    "materialBasedEssay": "सामग्री-आधारित लेखन (तर्कसंगत / सूचनात्मक पाठों की रचना)\n\nविषय-वस्तु प्रदर्शन और सामग्री का उपयोग (समझ क्षमता / पाठ संरचना):\n* प्रस्तावना संक्षिप्त है, पाठक की रुचि जगाती है, और विषय की ओर ले जाती है (घिसे-पिटे संक्रमणों से बचा गया है)।\n* एक सार्थक संरचना पहचानी जा सकती है, जो आवश्यक लक्ष्य पाठ-प्रकार (जैसे टिप्पणी, निबंध, लेख) के सभी घटकों के अनुरूप है।\n* विषय और उससे जुड़ी समस्या की शुरुआत में ही स्पष्ट रूपरेखा दी गई है।\n* आवश्यकतानुसार महत्वपूर्ण मूल अवधारणाओं को उचित रूप से समझाया गया है।\n* प्रस्तुत सभी सामग्रियों को ध्यान में रखा गया है और उन्हें सार्थक तथा विषय-वस्तु की दृष्टि से सटीक रूप से पाठ में शामिल किया गया है।\n* अन्य स्रोतों के कथनों में पारदर्शिता है (सही उद्धरण, व्याख्या और स्रोतों का संदर्भ)।\n* तथ्यों की प्रस्तुति, तर्क-वितर्क और स्वयं के आकलन के बीच स्पष्ट अंतर किया गया है।\n* तर्क-वितर्क व्यापक और सुविभेदित है (विषय के विभिन्न पहलुओं और संभावित प्रति-तर्कों को ध्यान में रखता है)।\n* व्यक्तिगत तर्क लक्षित पाठकों के लिए प्रेरक हैं, स्पष्ट रूप से संरचित, स्पष्ट किए गए और प्रमाणों/उदाहरणों से समर्थित हैं।\n* सामग्री से प्राप्त तर्कों के अलावा, स्वतंत्र तर्क और स्वयं का विषय-ज्ञान भी प्रस्तुत किया गया है।\n* अंत में तर्क-वितर्क को एक निष्कर्ष में समेटा गया है, जिसके बाद संभवतः भविष्य की संभावना पर एक दृष्टिकोण दिया गया है।\n\nभाषाई प्रदर्शन और पाठ रचना (प्रस्तुति क्षमता):\n* भाषाई रचना आवश्यक पाठ-प्रकार के अनुरूप है, जिसमें स्पष्ट, सटीक भाषा और स्वतंत्र वाक्य-रचनाएँ हैं।\n* शब्दावली, विषय-विशिष्ट शब्दों में प्रवीणता, और कार्यात्मक शैली सटीक, सुविभेदित और शैलीगत रूप से उपयुक्त हैं।\n* वाक्य-रचना सुगम, विविधतापूर्ण और व्याकरणिक रूप से जटिल है।\n* मानक त्रुटियाँ (व्याकरण, स्पेलिंग और विरामचिह्न में) पढ़ने के प्रवाह को बाधित नहीं करती हैं।",
    "literaryAnalysisPoetry": "प्रस्तुति क्षमता\n* 1. परीक्षार्थी अपने पाठ को सुसंगत, तार्किक, सुसंगतिपूर्ण और स्पष्ट चिंतन के साथ संरचित करता है:\n  - क्रियान्वयन में उप-कार्यों का उचित भारांकन\n  - कार्य की संरचित और उचित रूप से भारांकित योजना\n  - व्यक्तिगत कार्य-चरणों के बीच सुसंगत संबंध\n  - वाक्यों के बीच सुसंगत वैचारिक संबंध\n* 2. परीक्षार्थी विषय-विशिष्ट भाषा और पद्धतिगत आवश्यकताओं का ध्यान रखते हुए अभिव्यक्त करता है:\n  - क्रिया-स्तर और मेटा-स्तर के बीच पृथक्करण\n  - वर्णनात्मक, व्याख्यात्मक और मूल्यांकनात्मक कथनों के बीच युक्तियुक्त संबंध\n  - सार्थक संदर्भ में विशेष शब्दावली का उपयोग\n  - काल का सही ध्यान रखना\n  - उद्धृत वाणी (मोडैलिटी) का सही पुनरुत्पादन\n* 3. परीक्षार्थी उचित और सही उद्धरण देकर कथनों का समर्थन करता है:\n  - पूर्ण या संक्षिप्त उद्धरणों का तर्क-समर्थक भूमिका में सार्थक उपयोग\n* 4. परीक्षार्थी सामान्य भाषिक सटीकता, शैलीगत आत्मविश्वास और वैचारिक विभेदन के साथ अभिव्यक्त करता है:\n  - एक वस्तुनिष्ठ, दूरीयुक्त लेखन शैली\n  - लिखित भाषा का रजिस्टर\n  - वैचारिक रूप से अमूर्त अभिव्यक्ति क्षमता\n* 5. परीक्षार्थी शाब्दिक और वाक्य-रचनात्मक रूप से आत्मविश्वासपूर्ण, विविधतापूर्ण और जटिल (और साथ ही स्पष्ट) रूप से अभिव्यक्त करता है।\n* 6. परीक्षार्थी भाषाई रूप से सही लिखता है।"
  },
  "LatexEditor": {
    "insertFormula": "सूत्र",
    "insertFormulaHint": "कर्सर की स्थिति पर नया सूत्र डालें",
    "switchToRawLatex": "रॉ LaTeX पर स्विच करें",
    "switchToVisualEditor": "विज़ुअल एडिटर पर स्विच करें",
    "naturalLanguageHint": "इस सूत्र को सामान्य भाषा में वर्णित करें",
    "naturalLanguagePlaceholder": "जैसे \"0 से 10 तक x² का समाकलन\"",
    "naturalLanguageError": "अनुवाद विफल रहा। कृपया पुनः प्रयास करें।",
    "insert": "डालें",
    "removeFormula": "सूत्र हटाएं",
    "cancel": "रद्द करें"
  },
  "StudentExam": {
    "loading": "परीक्षा लोड हो रही है…",
    "examFallbackTitle": "परीक्षा",
    "classLabel": "कक्षा {{class}}",
    "namePlaceholder": "तुम्हारा नाम",
    "answeredCount": "{{answered}} / {{total}} के उत्तर दिए",
    "submit": "जमा करें",
    "signInRequiredTitle": "साइन इन आवश्यक",
    "signInRequiredBody": "इस परीक्षा को हल करने के लिए साइन इन करें।",
    "signInAction": "साइन इन पर जाएँ",
    "unavailableTitle": "उपलब्ध नहीं",
    "submittedTitle": "जमा हो गई",
    "submittedBody": "तुम्हारे उत्तर सहेज लिए गए हैं और जाँच के लिए तैयार हैं।",
    "errors": {
      "loadFailed": "परीक्षा लोड नहीं हो सकी।",
      "notFound": "यह परीक्षा मौजूद नहीं है।",
      "notSignedIn": "साइन इन नहीं किया गया।",
      "noAccess": "परीक्षा नहीं मिली, या पहुँच नहीं है।",
      "noTasks": "इस परीक्षा में अभी कोई प्रश्न नहीं हैं।",
      "uploadedExam": "यह परीक्षा बनाई नहीं, अपलोड की गई थी, इसलिए इसे ऑनलाइन नहीं भरा जा सकता।",
      "studentsOnly": "ऑनलाइन भरना केवल छात्र खातों के लिए उपलब्ध है।",
      "renderFailed": "परीक्षा प्रदर्शित नहीं की जा सकी।",
      "unreadableAnswers": "उत्तर पढ़े नहीं जा सके।",
      "submitFailed": "जमा करना विफल रहा।"
    },
    "canvas": {
      "undo": "पूर्ववत करें",
      "clear": "मिटाएँ",
      "pen": "पेन",
      "eraser": "इरेज़र",
      "redo": "फिर से करें",
      "zoom": "बड़ा करके बनाएँ",
      "zoomClose": "बड़ा दृश्य बंद करें",
      "penWidth": "पेन मोटाई {{width}}"
    }
  }
}
